$(document).ready(function () {
  hpEditionInit();
  $(window).on("orientationchange resize", hpEditionInit);

  function hpEditionInit() {
    $(".edition-modal-code .model-wrapper").removeClass("akaiki-active-edition-model");

    if ($(".edition-mySwiper-thumb").hasClass("slick-initialized")) {
      $(".edition-mySwiper-thumb").slick("unslick");
    }
    if ($(".edition-swiper-main").hasClass("slick-initialized")) {
      $(".edition-swiper-main").slick("unslick");
    }

    if (window.innerWidth <= 1024) {
      $(".model-wrapper-modal .edition-item").removeClass("d-none");
      $(".edition-control-item").off("mouseenter mouseleave");

      if (
        $(".edition-mySwiper-thumb").length > 0 &&
        !$(".edition-mySwiper-thumb").hasClass("slick-initialized")
      ) {
        $(".edition-mySwiper-thumb").slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: ".edition-swiper-main",
          centerMode: true,
          speed: 700,
          infinite: true,
          focusOnSelect: true,
          prevArrow: $(".edition-prev"),
          nextArrow: $(".edition-next"),
        });
      }

      if (
        $(".edition-swiper-main").length > 0 &&
        !$(".edition-swiper-main").hasClass("slick-initialized")
      ) {
        $(".edition-swiper-main").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: false,
          draggable: false,
          arrows: false,
          fade: true,
          asNavFor: ".edition-mySwiper-thumb",
        });
      }

      $(document).on("click", function (event) {
        if (
          !$(event.target).closest(
            ".edition-control-item, .model-wrapper-modal, .edition-control-swiper-item, .edition-control-swiper, .slick-arrow"
          ).length
        ) {
          $(".edition-modal-code .model-wrapper").removeClass("akaiki-active-edition-model");
          $(".edition-control-item").removeClass("akaiki-active-edition");
        }
      });

      $(".edition-control-item").on("click", function (e) {
        handleChangeActiveImage.call(this);
      });

      $(".edition-control-item, .edition-mySwiper-thumb .slick-track").on(
        "touchend",
        function (e) {
          handleChangeActiveImage.call(this);
        }
      );

      $(".edition-control-wrapper").on(
        "click",
        ".edition-control-swiper-item",
        function (e) {
          handleChangeActiveImage.call(this);
        }
      );
    }
    else {
      $(".attribute-image").addClass("hidden");
      $(".model-wrapper-modal .edition-item").addClass("d-none");
      $(".edition-control-item").removeClass("akaiki-active-edition");
      //xóa style của slick khi resize từ mobile
      $(".edition-item").each(function () {
        if (this.hasAttribute("style")) {
          $(this).removeAttr("style");
        }
      });
      handleHoverEdition();
    }
  }

  function handleChangeActiveImage() {
    if (window.innerWidth <= 1024) {
      $(".model-wrapper-modal .edition-item").removeClass("d-none");
      $(".edition-control-item").removeClass("akaiki-active-edition");
      $(".edition-control-item.slick-current").addClass("akaiki-active-edition");
      $(".edition-modal-code .model-wrapper").addClass("akaiki-active-edition-model");
    }
  }

  function handleHoverEdition() {
    if (window.innerWidth > 1024) {
      $(".edition-control-item").hover(
        function () {
          let editionVersion = $(this).attr("editionVersion");
          $(`.model-wrapper-modal .${editionVersion}`).removeClass("d-none");
          $(".edition-modal-code .model-wrapper").addClass(
            "akaiki-active-edition-model"
          );
          $(this).addClass("akaiki-active-edition");
          $(".edition-control-swiper").css("pointer-events", "auto");
        },
        function () {
          $(".edition-modal-code .model-wrapper").removeClass(
            "akaiki-active-edition-model"
          );
          $(".edition-control-item").removeClass("akaiki-active-edition");
          $(".edition-control-swiper").css("pointer-events", "none");
          $(".model-wrapper-modal .edition-item").addClass("d-none");
        }
      );
    };
  }

  initializeModalImg();

  $(window).on("orientationchange resize", function () {
    initializeModalImg();
  });

  function initializeModalImg() {
    if (window.innerWidth > 1024) {
      initializeImageToggle(".edition-control-item");
    } else {
      initializeImageToggle(".model-img");
    }
  }

  function initializeImageToggle(containerSelector) {
    $(containerSelector).each(function () {
      const $container = $(this);
      let currentIndex = 0;
      let $images = "";

      if (window.innerWidth > 1024) {
        let editionVersion = $container.attr("editionVersion");
        $images = $(".model-wrapper-modal")
          .find(`.${editionVersion}`)
          .find(".attribute-image");
      } else {
        $images = $container.find(".attribute-image");
      }

      // Hiển thị hình đầu tiên
      $images.eq(currentIndex).removeClass("hidden");

      $container.find(".attribute-toggle-button").on("click", function () {
        // Ẩn hình hiện tại
        $images.eq(currentIndex).addClass("hidden");

        // Tăng chỉ số và quay lại 0 nếu vượt quá số lượng hình ảnh
        currentIndex = (currentIndex + 1) % $images.length;

        // Hiển thị hình mới
        $images.eq(currentIndex).removeClass("hidden");
      });
    });
  }
});
